<template>
  <v-dialog v-model="changeDeductionTypeShow" persistent max-width="390">
    <v-card class="pa-6">
      <v-form ref="form">
        <v-select
          v-model="old_deduction_type"
          :items="deductionTypes"
          :rules="requiredRules"
          label="请选择要修改的评分类型"
        ></v-select>
        <v-combobox
          v-model="type"
          :items="deductionTypesSplit"
          label="请输入或选择评分类型"
        ></v-combobox>
        <v-select
          v-model="type_order"
          :items="deductionTypesOrder"
          :rules="requiredRules"
          label="请选择评分类型序号"
        ></v-select>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="green darken-1"
            text
            :disabled="pendingConfirm"
            @click="close"
            >取消</v-btn
          >
          <v-btn color="primary" :disabled="pendingConfirm" @click="save">
            确认
            <v-progress-circular
              v-if="pendingConfirm"
              indeterminate
              color="red"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

import http from '../http';

export default {
  data: () => ({
    requiredRules: [value => !!value || '必填.'],
    deductionTypesOrder: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    old_deduction_type: '',
    type: '',
    type_order: 1
  }),
  watch: {
    'type': function(val) {
      if (val && this.deductionTypesSplit.some(item => item === val)) {
        let order = this.deductionTypes.find(item => {
          return item.split('.')[1] === val;
        }).split('.')[0];

        this.type_order = parseInt(order);
        this.deductionTypesOrder = [parseInt(order)];
      } else {
        this.type_order = 1;
        this.deductionTypesOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'experiment',
      'changeDeductionTypeShow',
      'deductionTypes',
      'pendingConfirm'
    ]),
    deductionTypesSplit() {
      return this.deductionTypes.map(item => {
        return item.split('.')[1];
      });
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      let old_type = this.old_deduction_type.split('.')[1];
      let old_type_order = this.old_deduction_type.split('.')[0];

      http
        .patch(
          `rest/report_check_items?type=eq.${old_type}&type_order=eq.${old_type_order}`,
          {
            type: this.type ? this.type : old_type,
            type_order: this.type_order
          }
        )
        .then(() => {
          this.$store.dispatch('fetchDeductions', this.experiment.code);
          this.$store.commit('setDeductionTypeShow', false)
          this.clean();
        })
        .catch((err) => console.log(err));
    },
    close() {
      this.$store.commit('setDeductionTypeShow', !this.changeDeductionTypeShow);
      this.clean();
    },
    clean() {
      this.old_deduction_type = this.deductionTypes[0];
      this.type = '';
      this.type_order = 1;
    }
  },
  mounted() {
    this.clean();
  }
}
</script>

<style>

</style>
